import { useState } from "react"
import { IOrdersRegisteredOnOmieEntity } from "../../../Services/api/orders/orders.interface";
import { ShowOmieOrderDetailsUseCase } from "../../../Usecase/Orders/show-omie-order-details-usecase";
import { useToast } from "../../../Hooks/ToasContext";



interface IUseOmieOrderDetailsProps {
    showOmieOrderDetailsUseCase: ShowOmieOrderDetailsUseCase
}



export interface Task {
  id: string;
  content: {
    os: string;
    items: any; // ajuste o tipo conforme sua necessidade
    type?: 'checkbox' | 'click'
  };
}

const tasks: Record<string, Task> = {};
export function useOmieOrderDetails({ showOmieOrderDetailsUseCase }: IUseOmieOrderDetailsProps){
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState<IOrdersRegisteredOnOmieEntity | null>(null)
    const [omieOrderData, setOmieOrderData] = useState<IOrdersRegisteredOnOmieEntity | null>(null)
    const { showToast } = useToast()
    const [showImage, setShowImage] = useState('')

    const handleDetailsOmieOrder = async (orderId?: string) => {
      
        try {
          setLoading(true)
          
          const orderResult = await showOmieOrderDetailsUseCase.handle(String(orderId));
    
          if (orderResult.isFailure) {
      
            showToast(String(orderResult?.error?.error), 'error');
            return;
          }
    
          const result = orderResult.getValue();
    
          if(result?.id){
            setOmieOrderData(result)
          }
    
        } catch (error) {
          console.log("error handleShowOrder function: ", error)
        } finally {
          setLoading(false);
        }
      };
 

    return {
        loading,
        omieOrderData,
        handleDetailsOmieOrder,
        showImage,
        setShowImage
    }
}